export enum ReadAndUnderstoodType {
	No = 0,
	Yes = 1,
	Undefined = 2
}